module.exports = __webpack_public_path__ + "img/create.57d0040d.svg";